import { tenantApi } from "@/modules/tenant/services/tenantApi";
import type { Engine } from "../types/engine.types";
import type { ProvenanceMap } from "../types/boat.types";

export const engineApi = {
  // Paginated engine list. Returns { items, meta } (meta.filters carries facet counts).
  getEngines: (params: {
    page?: number;
    per_page?: number;
    search?: string;
    condition?: string | string[];
    manufacturer?: string | string[];
    status_id?: string | string[];
    location_id?: string | string[];
    attachment?: "loose" | "attached";
    sort_by?: string;
    sort_order?: string;
  }) => tenantApi.getPaginated<Engine>("/engines", { params }),

  // Single engine + tagged-boat history.
  getEngine: (id: string) => tenantApi.getOne<Engine>(`/engines/${id}`),

  // SP3-full slice 3 — the asset provenance projection (flat form keys; the
  // canvas hydrates its 4-state tints from this on resume + after a merge).
  getFieldSources: (id: string) =>
    tenantApi.getOne<ProvenanceMap>(`/engines/${id}/field-sources`),

  // SP2-D — manual CRUD.
  createEngine: (data: AssetWritePayload) => tenantApi.postOne<Engine>("/engines", data),
  updateEngine: (id: string, data: AssetWritePayload) => tenantApi.putOne<Engine>(`/engines/${id}`, data),
  deleteEngine: (id: string) => tenantApi.deleteOne(`/engines/${id}`),

  // SP4 slice 1 — mark-sold lifecycle. 422s with errors.active_link while the
  // engine is attached to a boat (D2: detach first).
  markSold: (id: string, data: MarkAssetSoldPayload) =>
    tenantApi.postOne<Engine>(`/engines/${id}/mark-sold`, data),
};

/** Shared+detail fields accepted by the engine/trailer write endpoints. */
export type AssetWritePayload = Record<string, string | number | null>;

/** All optional — staff can flag the asset sold and fill in details later. */
export interface MarkAssetSoldPayload {
  sold_price?: number;
  sold_date?: string;
  sold_to_customer_id?: string;
}
